class ValidatePaymentMethod extends ValidatePage {
    constructor(_parent) {
        super();
        this.parent = _parent;
        this.cc_name = { elm: '', id: '', classlist: '',  value: '' };
        this.cc_num = { elm: '', id: '', classlist: '',  value: '' };
        this.cc_month = { elm: '', id: '', classlist: '',  value: '' };
        this.cc_year = { elm: '', id: '', classlist: '',  value: '' };
        this.cc_cvv2 = { elm: '', id: '', classlist: '',  value: '' };
        this.cur_year = new Date().getFullYear();
        this.url = `ajax/instance_payment_method/`;

        this.payment_profile = '';

        this.debug = this.parent.debug.extends.ValidatePaymentMethod;
    }

    async _validate($this){
        this.define_elems($this);
        
        var cc_name = this.validate_cc_name();
        var cc_num = this.validate_cc_num();
        var cc_exp = this.validate_cc_exp();
        var cc_cvv2 = this.validate_cc_cvv();

        if(this.debug)
            console.log(this, {cc_name:cc_name, cc_num:cc_num, cc_exp:cc_exp, cc_cvv2:cc_cvv2}, "ValidatePaymentMethod - debug");

        if(!cc_name || !cc_num || !cc_exp || !cc_cvv2 )
            return false;
        else
            return true;
    }

    define_elems($this){
        this.cc_name = this.get_card_name($this);
        this.cc_num = this.parent.define_elem($this);
        this.cc_month = this.get_card_month($this);
        this.cc_year = this.get_card_year($this);
        this.cc_cvv2 = this.get_card_cvv2($this);
    }

    validate_cc_name(){
        if(this.cc_name.value == '' || this.cc_name.value.length <= 1){
            this.parent.failed_obj_push( { target: this.cc_name.id, msg: get_language_translation('MINIMUM_REQUIRED_LENGTH_OF_LANG') + ' 2' } );
            return false;
        }else{
            return true;
        }
    }

    validate_cc_num(){
        if(this.cc_cvv2.elm.hasClass('amex') && this.cc_num.value.length < 15 || !this.cc_cvv2.elm.hasClass('amex') && this.cc_num.value.length < 16 ){
            this.parent.failed_obj_push( { target: this.cc_num.id, msg: get_language_translation('LANG_MSG_INVALID_CARD_NUMBER') } );
            return false;
        }else{
            return true;
        }
    }

    validate_cc_exp(){
        var err_msg = false;
        var input = false;
                
        if(this.cc_year.value.length == 2 && this.cc_month.value.length == 0){
            err_msg = get_language_translation('LANG_MSG_EXP_DATE_REQUIRED');
            input = this.cc_month.id;
        }
        
        if(this.cc_year.formatted_year < this.cur_year){
            err_msg = get_language_translation('LANG_MSG_INVALIE_EXP_YEAR');
            input = this.cc_year.id;
        }
            
        if(this.cc_year.formatted_year == this.cur_year && this.cc_month.value < new Date().getMonth() + 1){
            err_msg = get_language_translation('LANG_MSG_INVALID_CARD_EXPIRATION');
            input = this.cc_month.id;
        }
        
        if(this.cc_month.value.length != 2 || this.cc_month.value > 12){
            err_msg = get_language_translation('LANG_MSG_INVALID_EXPIRATION_MONTH');
            input = this.cc_month.id;
        }
                
        if(isNaN(this.cc_month.value) || isNaN(this.cc_year.formatted_year)){
            err_msg = get_language_translation('LANG_MSG_NUMBERS_ONLY');
            input = this.cc_month.id;
        }

        if(err_msg){
            this.parent.failed_obj_push( { target: input, msg: err_msg, custom_section: 'am-exp-date-cont' } );
            return false;
        }else{
            return true;
        }
    }

    validate_cc_cvv(){
        var cvv_msg = false;

        if(this.cc_cvv2.value == '' || this.cc_cvv2.value.length > 0){
            if(this.cc_cvv2.elm.hasClass('amex')){
                if(this.cc_cvv2.value.length < 4)
                    cvv_msg = get_language_translation('LANG_INVALID_CVV2_CODE');
            }else{
                if(this.cc_cvv2.value.length != 3 )
                    cvv_msg = get_language_translation('LANG_INVALID_CVV2_CODE');
            }

            if(isNaN(this.cc_cvv2.value))
                cvv_msg = get_language_translation('LANG_INVALID_CVV2_CODE');
                        
            if(cvv_msg){
                this.parent.failed_obj_push( { target: this.cc_cvv2.id, msg: cvv_msg } );
                return false;
            }else{
                return true;
            }
        }else{
            return true;
        }
    }

    get_card_container($el){
        const $cardContiner = $el.parent().closest('.am-card-block');
        return $cardContiner;
    }
        
    get_card_name($el){
        const $cardContiner = this.get_card_container($el);
        const $cc_name = $cardContiner.find('.js-cc-name');
        var name = this.parent.define_elem($cc_name);
    
       return name
    }

    get_card_month($el){
        const $cardContiner = this.get_card_container($el);
        const $cc_month = $cardContiner.find('.js-cc_exp_month');
        var month = this.parent.define_elem($cc_month);
    
       return month
    }

    get_card_year($el){
        const $cardContiner = this.get_card_container($el);
        const $cc_year = $cardContiner.find('.js-cc_exp_year');

        var year = {
            elm: $cc_year, 
            id: $cc_year.attr('id'), 
            classlist: $cc_year.prop('className'), 
            value: $cc_year.val(),
            formatted_year: parseInt(String(this.cur_year).substring(0, 2) + $cc_year.val())
        };
    
       return year
    }

    get_card_cvv2($el){
        const $cardContiner = this.get_card_container($el);
        const $cc_cvv2 = $cardContiner.find('.js-cc-cvv2');
        var cvv2 = this.parent.define_elem($cc_cvv2);
    
       return cvv2
    }
} 